const DEFAULT_AIRCRAFT_PALETTE = [
  "#2563eb",
  "#7c3aed",
  "#0f766e",
  "#dc2626",
  "#d97706",
  "#0891b2",
  "#65a30d",
  "#be185d",
  "#4f46e5",
  "#c2410c",
  "#0ea5e9",
  "#9333ea"
];

export const normalizeHexColor = (value) => {
  const rawValue = String(value || "").trim();
  if (!rawValue) return null;
  const prefixed = rawValue.startsWith("#") ? rawValue : `#${rawValue}`;
  if (/^#[0-9A-Fa-f]{3}$/.test(prefixed) || /^#[0-9A-Fa-f]{6}$/.test(prefixed)) {
    return prefixed.toUpperCase();
  }
  return null;
};

export const colorIndexFromString = (value, modulo) => {
  if (!Number.isInteger(modulo) || modulo <= 0) return 0;
  let hash = 0;
  const str = String(value || "");
  for (let i = 0; i < str.length; i += 1) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % modulo;
};

export const resolveAircraftColor = ({
  preferredColor,
  seed,
  palette = DEFAULT_AIRCRAFT_PALETTE
}) => {
  const savedColor = normalizeHexColor(preferredColor);
  if (savedColor) return savedColor;
  return palette[colorIndexFromString(seed, palette.length)];
};

export const hexToRgba = (hex, alpha) => {
  const normalizedHex = normalizeHexColor(hex);
  if (!normalizedHex) return `rgba(37, 99, 235, ${alpha})`;
  const longHex = normalizedHex.length === 4
    ? `#${normalizedHex[1]}${normalizedHex[1]}${normalizedHex[2]}${normalizedHex[2]}${normalizedHex[3]}${normalizedHex[3]}`
    : normalizedHex;
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(longHex);
  if (!match) return `rgba(37, 99, 235, ${alpha})`;
  const [, r, g, b] = match;
  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${alpha})`;
};

export const buildAircraftColorMap = ({
  aircraftIds = [],
  aircraftNames = [],
  aircraftColors = [],
  palette = DEFAULT_AIRCRAFT_PALETTE
}) => aircraftIds.reduce((memo, aircraftId, index) => {
  if (!memo[aircraftId]) {
    const name = aircraftNames[index] || "";
    memo[aircraftId] = {
      color: resolveAircraftColor({
        preferredColor: aircraftColors[index],
        seed: name || aircraftId,
        palette
      }),
      name
    };
  }
  return memo;
}, {});

export const ensureFlightRecordAircraftColorHelpers = () => {
  window.FlightRecordAircraftColors ||= {};
  Object.assign(window.FlightRecordAircraftColors, {
    DEFAULT_AIRCRAFT_PALETTE,
    normalizeHexColor,
    colorIndexFromString,
    resolveAircraftColor,
    hexToRgba,
    buildAircraftColorMap
  });
};
